// extracted by mini-css-extract-plugin
export default {"table":"styles_table__XeyvY","button":"styles_button__bkiB-","title":"styles_title__nl8mM"};